/* eslint-disable no-unused-vars */

export enum ProductTier {
  BASIC = 'basic',
}
